import el from "@cypherpotato/el";
import { Button } from "./button";
import { Icon } from "./icon";
import { MutedText } from "./text";
import { TagBadge } from "./badge";

export function FileInput({ accept, multiple = false, ariaLabel = multiple ? "Choose files" : "Choose file" }) {

    const fileData = el.state.create(null);
    const fileName = el.state.create(null);

    const fileInput = el("input[type=file]", {
        accept,
        multiple,
        onInput(event) {
            if (event.target.files && event.target.files.length > 0) {
                if (multiple) {
                    fileName.value = el.fragment(...[...event.target.files].map(f => TagBadge(f.name, { style: { margin: "0 2px" } })));
                    fileData.value = event.target.files;
                } else {
                    fileName.value = event.target.value.split(/[\\\/]/g).pop();
                    fileData.value = event.target.files[0];
                }
            } else {
                fileName.value = null;
                fileData.value = null;
            }
        }
    });

    return el("div.file-input[form-slot]",
        el.state.listening([fileName], () =>
            el("label", fileName.value || MutedText("No file selected"))
        ),
        Button(Icon("folder-open-line"), {
            type: "button",
            ariaLabel
        }),
        {
            onClick() {
                fileInput.click();
            },
            $properties: {
                value: {
                    get() {
                        return fileData.value;
                    }
                }
            }
        }
    )
}
